// Avoid having an export on the first line for istanbul

export const COLORS = {
  ERROR_EDGE: 'var(--borderDanger)',
  DARK_ERROR_EDGE: 'var(--borderDanger)',
  HIGHLIGHT_EDGE: 'var(--borderMainActive)',
  DARK_HIGHLIGHT_EDGE: 'var(--borderMainActive)',
  UNHIGHLIGHT_EDGE: 'var(--borderMain)',
  DARK_UNHIGHLIGHT_EDGE: 'var(--borderMain)',
  SELECTED_NODE: '#AA49CC', // Unused?
  NODE_BORDER: '#5CC6E7', // Unused?
  NODE_BACKGROUND: '#CFEEF8', // Unused?
  DARK_TEXT: 'var(--fgMain)',
  LIGHT_TEXT: 'var(--fgMain)',
  LINK: 'var(--fgBrand)',
  GRAY_500: 'var(--fgDecorative)',
  DARK_BG_DOTS: 'var(--fgVizNeutral)',
  BG_DOTS: 'var(--fgVizNeutral)',
} as const;

export const SYSTEM_FONT_FAMILY = 'var(--fontFamily)';

export const getEdgeColor = ({
  isHighlighted,
  isError,
}: {
  isHighlighted: boolean;
  isError: boolean;
}) => {
  if (isHighlighted) {
    if (isError) {
      return COLORS.ERROR_EDGE;
    }
    return COLORS.HIGHLIGHT_EDGE;
  }
  return COLORS.UNHIGHLIGHT_EDGE;
};
